import { render, staticRenderFns } from "./GigGuide.vue?vue&type=template&id=53ac7288&scoped=true&"
import script from "./GigGuide.vue?vue&type=script&lang=js&"
export * from "./GigGuide.vue?vue&type=script&lang=js&"
import style0 from "./GigGuide.vue?vue&type=style&index=0&id=53ac7288&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ac7288",
  null
  
)

export default component.exports